import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { ShiftRequest } from './shift-request.model';
import { ShiftResponse } from './shift-response.model';

@Injectable({
  providedIn: 'root',
})
export class ShiftsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  getShifts(workspaceId: string): Observable<ShiftResponse[]> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shifts`
    );

    return this.httpClient.get<ShiftResponse[]>(url);
  }

  getShift(workspaceId: string, shiftId: string): Observable<ShiftResponse> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shifts/${shiftId}`
    );

    return this.httpClient.get<ShiftResponse>(url);
  }

  createShift(workspaceId: string, request: ShiftRequest): Observable<void> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shifts`
    );

    return this.httpClient.post<void>(url, request);
  }

  updateShift(
    workspaceId: string,
    shiftId: string,
    request: ShiftRequest
  ): Observable<void> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shifts/${shiftId}`
    );

    return this.httpClient.put<void>(url, request);
  }

  deleteShift(workspaceId: string, shiftId: string): Observable<void> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shifts/${shiftId}`
    );

    return this.httpClient.delete<void>(url);
  }
}